<ws-modal-wrapper [headerLabel]="(isBelowParcelLevel ? 'Parcel: ' + entityData.parcelAcctNum : entityData.description)"
                  [subHeaderLabel]="(isBelowParcelLevel ? entityData.description : null)"
                  [isHeaderLink]="isBelowParcelLevel"
                  (headerClick)="loadParentComments()"
                  [useAceStyles]="true"
                  (cancel)="cancel()"
                  [isEditing]="isEditing"
                  [loading]="loading"
                  [backdropClick]="true"
                  [hideFooter]="true">
    @if (!editingComment) {
        <div class="comment-modal-body">
            <div class="comment-controls ws-flex-container-horizontal ws-flex-align-items-center ws-flex-justify-content-center">
                <label style="margin: 0;">Show: </label>
                <ws-select class="show-control"
                           [options]="years"
                           [isPrimitive]="true"
                           (selectedOptionChanged)="yearChanged()"
                           [(ngModel)]="yearFilter"
                           [disabled]="loading || commentList.length === 0 || entityData.disableYearSelection">
                </ws-select>
                <ws-select class="show-control"
                           [options]="entityTypes"
                           labelProperty="text"
                           [returnEntireOption]="true"
                           (selectedOptionChanged)="entityTypeChanged()"
                           [(ngModel)]="entityTypeFilter"
                           [disabled]="loading || commentList.length === 0 || entityData.disableCommentTypeSelection">
                </ws-select>
                @if (childLabel && entityData.entityTypeID !== EntityTypeIds.COMPANY) {
                    <div class="checkbox">
                        <label>
                            <input type="checkbox"
                                   (click)="includeChildrenChanged()"
                                   [(ngModel)]="includeChildren"
                                   [disabled]="loading">
                            Include {{ childLabel }}
                        </label>
                    </div>
                }
            </div>
            <!-- Pinned Comment -->
            @if (pinnedComment && commentList.length > 0 && !loading) {
                <div
                    class="pinned-comment list-group comment-container list-border"
                    [ngStyle]="{'max-height': pinnedComment ? '38vh' : '58vh' }">
                    <div class="pinned-button">
                        <button
                            class="ace-btn btn-text p-0"
                            title="Pinned comments will be included in PSR Report, Action Views, SMART, etc."
                            [disabled]="!entityData.canEdit"
                            (click)="unpinComment(pinnedComment)">
                            <i class="fa fa-thumb-tack"></i>
                        </button>
                    </div>
                    <div class="list-group-item clickable">
                        <comment-list-item [comment]="pinnedComment"
                                           [pinned]="true"
                                           [canEdit]="entityData.canEdit"
                                           (editComment)="editComment(pinnedComment)">
                        </comment-list-item>
                    </div>
                </div>
            }
            <!-- Main Comment List -->
            @if (commentList.length > 0 && !loading) {
                <div class="list-group comment-container" [ngClass]="{'list-border': commentList.length > 0}">
                    @for (comment of unpinnedComments; track commentTrackBy($index, comment)) {
                        <div class="list-group-item clickable"
                             style="word-break: break-word;"
                        >
                            <comment-list-item [comment]="comment"
                                               [canEdit]="entityData.canEdit"
                                               [loading]="loading"
                                               (editComment)="editComment(comment)"
                                               (pinComment)="pinComment(comment)">
                            </comment-list-item>
                        </div>
                    }
                </div>
            }
            @if (commentList.length === 0 && !loading) {
                <div class="comment-list-empty">
                    <div><h3>No comments found</h3></div>
                </div>
            }
        </div>
        @if (!editingComment) {
            <div class="ace-button-container ws-button-row" style="padding-top: 15px">
                @if (entityData?.canEdit) {
                    <button class="ace-btn btn-primary" (click)="addComment()" [disabled]="loading">Add Comment</button>
                }
                <button class="ace-btn btn-primary" (click)="cancel()" [disabled]="loading">Done</button>
            </div>
        }
    }

    @if (editingComment) {
        <comments-edit
            [availableCommentTypes]="params.availableCommentTypes"
            [updateComment]="updateComment"
            [isNewComment]="isNewComment"
            [entityData]="entityData"
            [loading]="loading"
            (cancelEdit)="cancelEdit()"
            (getAllComments)="getAllComments()"
        ></comments-edit>
    }

</ws-modal-wrapper>
